const getLabel = (label, value, singularLabel = null) => {
  let newLabel = label
  if (null !== singularLabel && value === 1) {
    newLabel = singularLabel
  }

  return `${value}${newLabel}`
}

const numberWithLabelChoices = (values, label, singularLabel = null) => (
  values.map((value) => ({
    value,
    label: getLabel(label, value, singularLabel)
  }))
)

export default numberWithLabelChoices



// WEBPACK FOOTER //
// ./src/utils/forms/numberWithLabelChoices.js